import { RuntimeConfig } from './globalSingletons';

export const getDeepLink = (path?: string) => {
    const scheme = RuntimeConfig.get()?.deepLink?.scheme;
    if (scheme) {
        return `${scheme}${path}`;
    }
    return '';
};
